import React, { useCallback, useEffect, useMemo, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Redirect } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Stack,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  CircularProgress,
  Autocomplete,
  Grid,
  Tooltip,
  Backdrop,
  Fade,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import PlaylistAddCheckCircleRoundedIcon from "@mui/icons-material/PlaylistAddCheckCircleRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import RotateLeftRoundedIcon from "@mui/icons-material/RotateLeftRounded";
import RotateRightRoundedIcon from "@mui/icons-material/RotateRightRounded";
import ZoomInRoundedIcon from "@mui/icons-material/ZoomInRounded";
import ZoomOutRoundedIcon from "@mui/icons-material/ZoomOutRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import RouteRoundedIcon from "@mui/icons-material/RouteRounded";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";

const DlvStatus = () => {
  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
    return null;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      LocalstorageHelper.RemoveUserToken();
    }, 3600000);
    return () => clearTimeout(timer);
  }, []);

  const monthStart = dayjs().startOf("month");
  const monthEnd = dayjs().endOf("month");

  const [fromdate, setfromdate] = useState(monthStart);
  const [todate, settodate] = useState(monthEnd);

  const [rows, setrows] = useState([]);
  const [loading, setloading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [partyFilter, setPartyFilter] = useState(null);
  const [vehicleFilter, setVehicleFilter] = useState(null);
  const [invoiceFilter, setInvoiceFilter] = useState(null);
  const [dlvnoFilter, setDlvnoFilter] = useState(null);
  const [lineFilter, setLineFilter] = useState(null);
  const [boxwiseStatusFilter, setBoxwiseStatusFilter] = useState(null);
  const [deliveryStatusFilter, setDeliveryStatusFilter] = useState(null);
  const [finalStatusFilter, setFinalStatusFilter] = useState(null);
  const [deliveredByFilter, setDeliveredByFilter] = useState(null);
  const [unloadEntryFilter, setUnloadEntryFilter] = useState(null);

  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewFileName, setPreviewFileName] = useState("document");
  const [previewError, setPreviewError] = useState("");
  const [previewMimeType, setPreviewMimeType] = useState("");
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);

  const formatDate = (value) => {
    if (!value) return "";
    const d = dayjs(value);
    return d.isValid() ? d.format("DD/MM/YYYY") : value;
  };

  const formatTime = (value) => {
    if (!value) return "";
    const text = String(value);
    return text.length >= 5 ? text.slice(0, 5) : text;
  };

  const safeJsonArray = (value) => {
    if (Array.isArray(value)) return value;
    if (!value) return [];
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
    return [];
  };

  const getStatusChip = (value) => {
    const v = String(value || "").toLowerCase();
    let color = "default";

    if (v.includes("delivered") || v === "unloaded" || v.includes("completed")) {
      color = "success";
    } else if (v === "loaded" || v.includes("transit")) {
      color = "info";
    } else if (v.includes("partial") || v.includes("mixed")) {
      color = "warning";
    } else if (v.includes("undelivered") || v.includes("cancelled")) {
      color = "error";
    }

    return (
      <Chip
        label={value || "-"}
        color={color}
        size="small"
        sx={{
          height: 22,
          fontSize: "0.69rem",
          fontWeight: 700,
          borderRadius: "999px",
          "& .MuiChip-label": {
            px: 1,
          },
        }}
      />
    );
  };

  const getSimpleChip = (value, successText = "Yes", pendingText = "No") => {
    const yes = Boolean(value);
    return (
      <Chip
        label={yes ? successText : pendingText}
        color={yes ? "success" : "default"}
        size="small"
        sx={{ height: 22, fontSize: "0.69rem", fontWeight: 700 }}
      />
    );
  };

  const getModeChip = (value) => {
    const text = String(value || "N/A");
    const lower = text.toLowerCase();

    let color = "default";
    if (lower.includes("partner")) color = "secondary";
    else if (lower.includes("transporter")) color = "primary";
    else if (lower.includes("scan")) color = "success";
    else if (lower.includes("manual")) color = "warning";
    else if (lower.includes("mixed")) color = "info";

    return (
      <Chip
        label={text}
        color={color}
        size="small"
        sx={{
          height: 22,
          fontSize: "0.69rem",
          fontWeight: 700,
          "& .MuiChip-label": { px: 1 },
        }}
      />
    );
  };

  const revokePreviewUrl = useCallback(() => {
    setPreviewUrl((prev) => {
      if (prev) {
        try {
          URL.revokeObjectURL(prev);
        } catch (e) {
          console.error(e);
        }
      }
      return "";
    });
  }, []);

  const closePreviewModal = useCallback(() => {
    setPreviewOpen(false);
    setPreviewLoading(false);
    setPreviewError("");
    setPreviewTitle("");
    setPreviewFileName("document");
    setPreviewMimeType("");
    setRotation(0);
    setZoom(1);
    revokePreviewUrl();
  }, [revokePreviewUrl]);

  useEffect(() => {
    return () => {
      revokePreviewUrl();
    };
  }, [revokePreviewUrl]);

  const fetchAndPreviewDocument = useCallback(
    async (loadid, doctype, title, fileNamePrefix) => {
      if (!loadid) {
        toast.info("Invalid document reference");
        return;
      }

      try {
        setPreviewOpen(true);
        setPreviewLoading(true);
        setPreviewError("");
        setPreviewTitle(title || "Document");
        setPreviewFileName(fileNamePrefix || "document");
        setPreviewMimeType("");
        setRotation(0);
        setZoom(1);
        revokePreviewUrl();

        const response = await fetch(
          `/spare/delivery/dlvstatus/document/${loadid}/${doctype}`,
          {
            method: "GET",
            headers: {
              sptoken: userToken,
            },
          }
        );

        if (!response.ok) {
          let errMessage = "Failed to load document";
          try {
            const text = await response.text();
            if (text) errMessage = text;
          } catch (e) {
            console.error(e);
          }
          throw new Error(errMessage);
        }

        const blob = await response.blob();
        setPreviewMimeType(blob.type || "");

        const objectUrl = URL.createObjectURL(blob);
        setPreviewUrl(objectUrl);
      } catch (err) {
        console.error(err);
        setPreviewError(err.message || "Unable to load document");
        toast.error(err.message || "Unable to load document");
      } finally {
        setPreviewLoading(false);
      }
    },
    [revokePreviewUrl, userToken]
  );

  const downloadPreview = useCallback(() => {
    if (!previewUrl) return;

    let ext = "jpg";
    if (previewMimeType === "application/pdf") ext = "pdf";
    else if (previewMimeType === "image/png") ext = "png";
    else if (previewMimeType === "image/webp") ext = "webp";
    else if (previewMimeType === "image/jpeg") ext = "jpg";

    const link = document.createElement("a");
    link.href = previewUrl;
    link.download = `${previewFileName}.${ext}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [previewUrl, previewFileName, previewMimeType]);

  const handleStatusFetch = useCallback(async () => {
    try {
      setloading(true);

      const body = {
        fromdate: fromdate ? dayjs(fromdate).format("YYYY-MM-DD") : null,
        todate: todate ? dayjs(todate).format("YYYY-MM-DD") : null,
      };

      const response = await fetch("/spare/delivery/dlvstatus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          sptoken: userToken,
        },
        body: JSON.stringify(body),
      });

      const jsonData = await response.json();

      if (!response.ok) {
        throw new Error(jsonData?.message || "Failed to fetch delivery status");
      }

      let finalRows = [];

      if (Array.isArray(jsonData)) {
        finalRows = jsonData;
      } else if (jsonData?.type === "success" && Array.isArray(jsonData?.data)) {
        finalRows = jsonData.data;
      }

      setrows(
        finalRows.map((item, index) => ({
          id: item.loadid || item.billheaderid || index + 1,
          ...item,
          billno: item.billno || item.invoice || "",
          partydetails: item.partydetails || item.party || "",
          linename: item.linename || "",
          delivered_by: item.delivered_by || "N/A",
          unload_entry_type: item.unload_entry_type || "N/A",
          box_details: safeJsonArray(item.box_details),
        }))
      );
    } catch (err) {
      console.error(err.message);
      toast.error(err.message || "Something went wrong");
      setrows([]);
    } finally {
      setloading(false);
    }
  }, [fromdate, todate, userToken]);

  useEffect(() => {
    handleStatusFetch();
  }, [handleStatusFetch]);

  const makeOptions = (list) => {
    const map = new Map();
    list.forEach((val) => {
      const label = String(val || "").trim();
      if (label) map.set(label, { label, value: label });
    });
    return Array.from(map.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  };

  const partyOptions = useMemo(() => makeOptions(rows.map((row) => row.partydetails)), [rows]);
  const vehicleOptions = useMemo(() => makeOptions(rows.map((row) => row.vehicleno)), [rows]);
  const invoiceOptions = useMemo(() => makeOptions(rows.map((row) => row.billno)), [rows]);
  const dlvnoOptions = useMemo(() => makeOptions(rows.map((row) => row.dlvno)), [rows]);
  const lineOptions = useMemo(() => makeOptions(rows.map((row) => row.linename)), [rows]);
  const boxwiseStatusOptions = useMemo(() => makeOptions(rows.map((row) => row.boxwise_status)), [rows]);
  const deliveryStatusOptions = useMemo(() => makeOptions(rows.map((row) => row.dlvstatus_text)), [rows]);
  const finalStatusOptions = useMemo(() => makeOptions(rows.map((row) => row.final_status)), [rows]);
  const deliveredByOptions = useMemo(() => makeOptions(rows.map((row) => row.delivered_by)), [rows]);
  const unloadEntryOptions = useMemo(() => makeOptions(rows.map((row) => row.unload_entry_type)), [rows]);

  const filteredRows = useMemo(() => {
    return rows.filter((row) => {
      const search = searchText.trim().toLowerCase();

      const searchMatch =
        !search ||
        String(row.billno || "").toLowerCase().includes(search) ||
        String(row.partydetails || "").toLowerCase().includes(search) ||
        String(row.vehicleno || "").toLowerCase().includes(search) ||
        String(row.dlvno || "").toLowerCase().includes(search) ||
        String(row.linename || "").toLowerCase().includes(search) ||
        String(row.boxwise_status || "").toLowerCase().includes(search) ||
        String(row.dlvstatus_text || "").toLowerCase().includes(search) ||
        String(row.final_status || "").toLowerCase().includes(search) ||
        String(row.delivered_by || "").toLowerCase().includes(search) ||
        String(row.unload_entry_type || "").toLowerCase().includes(search) ||
        row.box_details.some((b) =>
          String(b?.boxno || "").toLowerCase().includes(search)
        );

      const partyMatch =
        !partyFilter ||
        String(row.partydetails || "").toLowerCase() ===
          String(partyFilter?.value || "").toLowerCase();

      const vehicleMatch =
        !vehicleFilter ||
        String(row.vehicleno || "").toLowerCase() ===
          String(vehicleFilter?.value || "").toLowerCase();

      const invoiceMatch =
        !invoiceFilter ||
        String(row.billno || "").toLowerCase() ===
          String(invoiceFilter?.value || "").toLowerCase();

      const dlvnoMatch =
        !dlvnoFilter ||
        String(row.dlvno || "").toLowerCase() ===
          String(dlvnoFilter?.value || "").toLowerCase();

      const lineMatch =
        !lineFilter ||
        String(row.linename || "").toLowerCase() ===
          String(lineFilter?.value || "").toLowerCase();

      const boxwiseMatch =
        !boxwiseStatusFilter ||
        String(row.boxwise_status || "").toLowerCase() ===
          String(boxwiseStatusFilter?.value || "").toLowerCase();

      const deliveryMatch =
        !deliveryStatusFilter ||
        String(row.dlvstatus_text || "").toLowerCase() ===
          String(deliveryStatusFilter?.value || "").toLowerCase();

      const finalMatch =
        !finalStatusFilter ||
        String(row.final_status || "").toLowerCase() ===
          String(finalStatusFilter?.value || "").toLowerCase();

      const deliveredByMatch =
        !deliveredByFilter ||
        String(row.delivered_by || "").toLowerCase() ===
          String(deliveredByFilter?.value || "").toLowerCase();

      const unloadEntryMatch =
        !unloadEntryFilter ||
        String(row.unload_entry_type || "").toLowerCase() ===
          String(unloadEntryFilter?.value || "").toLowerCase();

      return (
        searchMatch &&
        partyMatch &&
        vehicleMatch &&
        invoiceMatch &&
        dlvnoMatch &&
        lineMatch &&
        boxwiseMatch &&
        deliveryMatch &&
        finalMatch &&
        deliveredByMatch &&
        unloadEntryMatch
      );
    });
  }, [
    rows,
    searchText,
    partyFilter,
    vehicleFilter,
    invoiceFilter,
    dlvnoFilter,
    lineFilter,
    boxwiseStatusFilter,
    deliveryStatusFilter,
    finalStatusFilter,
    deliveredByFilter,
    unloadEntryFilter,
  ]);

  const summary = useMemo(() => {
    const total = filteredRows.length;
    const pending = filteredRows.filter(
      (r) => String(r.final_status || "").toLowerCase() === "pending"
    ).length;
    const loaded = filteredRows.filter((r) => {
      const status = String(r.final_status || "").toLowerCase();
      return status === "loaded" || status === "partially loaded";
    }).length;
    const unloaded = filteredRows.filter((r) => {
      const status = String(r.final_status || "").toLowerCase();
      return status === "unloaded" || status === "partially unloaded";
    }).length;
    const delivered = filteredRows.filter(
      (r) => String(r.final_status || "").toLowerCase() === "delivered"
    ).length;
    const undelivered = filteredRows.filter(
      (r) => String(r.final_status || "").toLowerCase() === "undelivered"
    ).length;

    return { total, pending, loaded, unloaded, delivered, undelivered };
  }, [filteredRows]);

  const openDetails = (row) => {
    setSelectedRow(row);
    setDetailsOpen(true);
  };

  const closeDetails = () => {
    setDetailsOpen(false);
    setSelectedRow(null);
  };

  const clearAllFilters = () => {
    setSearchText("");
    setPartyFilter(null);
    setVehicleFilter(null);
    setInvoiceFilter(null);
    setDlvnoFilter(null);
    setLineFilter(null);
    setBoxwiseStatusFilter(null);
    setDeliveryStatusFilter(null);
    setFinalStatusFilter(null);
    setDeliveredByFilter(null);
    setUnloadEntryFilter(null);
  };

  const compactColumns = useMemo(
    () => [
      {
        field: "billno",
        headerName: "Bill No",
        minWidth: 150,
        flex: 0.95,
      },
      {
        field: "billdate",
        headerName: "Date",
        minWidth: 110,
        flex: 0.75,
        renderCell: (params) => formatDate(params.value),
      },
      {
        field: "partydetails",
        headerName: "Party",
        minWidth: 290,
        flex: 1.9,
      },
      {
        field: "linename",
        headerName: "Line",
        minWidth: 150,
        flex: 0.95,
        renderCell: (params) => params.value || "-",
      },
      {
        field: "vehicleno",
        headerName: "Vehicle",
        minWidth: 125,
        flex: 0.8,
        renderCell: (params) => params.value || "-",
      },
      {
        field: "dlvno",
        headerName: "DLV No",
        minWidth: 90,
        flex: 0.55,
        renderCell: (params) => params.value || "-",
      },
      {
        field: "boxwise_status",
        headerName: "Box Status",
        minWidth: 150,
        flex: 0.95,
        renderCell: (params) => getStatusChip(params.value || "Pending"),
      },
      {
        field: "final_status",
        headerName: "Final",
        minWidth: 145,
        flex: 0.9,
        renderCell: (params) => getStatusChip(params.value || "Pending"),
      },
      {
        field: "box_summary",
        headerName: "Boxes",
        minWidth: 90,
        flex: 0.5,
        sortable: false,
        renderCell: (params) => (
          <Typography variant="body2" fontWeight={700} sx={{ fontSize: "0.78rem" }}>
            {`${params.row.unloaded_boxes || 0}/${params.row.total_boxes || 0}`}
          </Typography>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        minWidth: 100,
        flex: 0.65,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Button
            size="small"
            variant="contained"
            onClick={() => openDetails(params.row)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              minWidth: 70,
              height: 28,
              fontSize: "0.72rem",
              px: 1.4,
              boxShadow: "none",
            }}
          >
            View
          </Button>
        ),
      },
    ],
    []
  );

  const SummaryCard = ({ title, value, icon, color }) => (
    <Card
      sx={{
        borderRadius: 2.5,
        boxShadow: 1,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <CardContent sx={{ p: 1.2, "&:last-child": { pb: 1.2 } }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="caption" color="text.secondary">
              {title}
            </Typography>
            <Typography variant="h6" fontWeight={700} sx={{ color, lineHeight: 1.1 }}>
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: `${color}15`,
              color,
            }}
          >
            {icon}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );

  const DetailCard = ({ title, children }) => (
    <Card
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "rgba(25,118,210,0.04)",
        }}
      >
        <Typography variant="subtitle2" fontWeight={700}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5 }}>{children}</Box>
    </Card>
  );

  const DetailItem = ({
    label,
    value,
    chip = false,
    boolChip = false,
    modeChip = false,
    doc = false,
    onDocClick,
  }) => (
    <Box
      sx={{
        p: 1.15,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "#e8edf3",
        bgcolor: "#fafcff",
        minHeight: 58,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontSize: "0.69rem", letterSpacing: 0.2 }}
      >
        {label}
      </Typography>

      <Box sx={{ mt: 0.55 }}>
        {chip ? (
          getStatusChip(value)
        ) : boolChip ? (
          getSimpleChip(value)
        ) : modeChip ? (
          getModeChip(value)
        ) : doc ? (
          <Button
            size="small"
            variant={value ? "contained" : "outlined"}
            disabled={!value}
            onClick={onDocClick}
            startIcon={<ImageRoundedIcon />}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              fontSize: "0.72rem",
              px: 1.1,
              minHeight: 28,
              boxShadow: "none",
            }}
          >
            {value ? "View" : "N/A"}
          </Button>
        ) : (
          <Typography
            variant="body2"
            fontWeight={700}
            sx={{ fontSize: "0.81rem", color: "#1f2937" }}
          >
            {value || "-"}
          </Typography>
        )}
      </Box>
    </Box>
  );

  const previewIsPdf = previewMimeType === "application/pdf";
  const previewIsImage =
    previewMimeType.startsWith("image/") ||
    previewMimeType === "application/octet-stream";

  const isSignaturePreview = previewTitle === "Customer Sign";

  return (
    <div>
      <Sidebar
        Title={"DELIVERY DASHBOARD"}
        expandedPanel={"panel2"}
        children={
          <Box sx={{ width: "100%", p: 1.2 }}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 2,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Box
                sx={{
                  p: 1.5,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  background:
                    "linear-gradient(90deg, rgba(25,118,210,0.08) 0%, rgba(25,118,210,0.02) 100%)",
                }}
              >
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "flex-start", md: "center" }}
                  spacing={1}
                >
                  <Box>
                    <Typography variant="h6" fontWeight={700}>
                      Delivery Dashboard
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Compact invoice, line, partner and unload tracking
                    </Typography>
                  </Box>

                  <Stack direction="row" spacing={1}>
                    <Button
                      variant="outlined"
                      onClick={clearAllFilters}
                      sx={{ borderRadius: 2, textTransform: "none" }}
                    >
                      Clear
                    </Button>

                    <Button
                      variant="contained"
                      startIcon={
                        loading ? (
                          <CircularProgress size={16} color="inherit" />
                        ) : (
                          <RefreshRoundedIcon />
                        )
                      }
                      onClick={handleStatusFetch}
                      disabled={loading}
                      sx={{ borderRadius: 2, textTransform: "none" }}
                    >
                      Refresh
                    </Button>
                  </Stack>
                </Stack>
              </Box>

              <Box sx={{ p: 1.5 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={1.4}>
                    <Grid container spacing={1.1}>
                      <Grid item xs={12} md={1.6}>
                        <DatePicker
                          label="From Date"
                          inputFormat="DD/MM/YYYY"
                          value={fromdate}
                          onChange={(newValue) => setfromdate(newValue)}
                          renderInput={(params) => (
                            <TextField {...params} size="small" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.6}>
                        <DatePicker
                          label="To Date"
                          inputFormat="DD/MM/YYYY"
                          value={todate}
                          onChange={(newValue) => settodate(newValue)}
                          renderInput={(params) => (
                            <TextField {...params} size="small" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={3.1}>
                        <TextField
                          size="small"
                          label="Search Bill / Party / Line / Vehicle / DLV / Box"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={1.8}>
                        <Autocomplete
                          options={partyOptions}
                          value={partyFilter}
                          onChange={(event, newValue) => setPartyFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Party" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.5}>
                        <Autocomplete
                          options={lineOptions}
                          value={lineFilter}
                          onChange={(event, newValue) => setLineFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Line" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.5}>
                        <Autocomplete
                          options={vehicleOptions}
                          value={vehicleFilter}
                          onChange={(event, newValue) => setVehicleFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Vehicle" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.5}>
                        <Autocomplete
                          options={invoiceOptions}
                          value={invoiceFilter}
                          onChange={(event, newValue) => setInvoiceFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Bill No" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.5}>
                        <Autocomplete
                          options={dlvnoOptions}
                          value={dlvnoFilter}
                          onChange={(event, newValue) => setDlvnoFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="DLV No" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.8}>
                        <Autocomplete
                          options={deliveredByOptions}
                          value={deliveredByFilter}
                          onChange={(event, newValue) => setDeliveredByFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Delivered By" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.8}>
                        <Autocomplete
                          options={unloadEntryOptions}
                          value={unloadEntryFilter}
                          onChange={(event, newValue) => setUnloadEntryFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Unload Entry" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.8}>
                        <Autocomplete
                          options={boxwiseStatusOptions}
                          value={boxwiseStatusFilter}
                          onChange={(event, newValue) => setBoxwiseStatusFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Box Status" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.8}>
                        <Autocomplete
                          options={deliveryStatusOptions}
                          value={deliveryStatusFilter}
                          onChange={(event, newValue) => setDeliveryStatusFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Delivery" fullWidth />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.8}>
                        <Autocomplete
                          options={finalStatusOptions}
                          value={finalStatusFilter}
                          onChange={(event, newValue) => setFinalStatusFilter(newValue)}
                          getOptionLabel={(option) => option?.label || ""}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Final Status" fullWidth />
                          )}
                        />
                      </Grid>
                    </Grid>

                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr 1fr",
                          md: "repeat(6, 1fr)",
                        },
                        gap: 1,
                      }}
                    >
                      <SummaryCard
                        title="Total"
                        value={summary.total}
                        icon={<Inventory2RoundedIcon fontSize="small" />}
                        color="#1976d2"
                      />
                      <SummaryCard
                        title="Pending"
                        value={summary.pending}
                        icon={<PendingActionsRoundedIcon fontSize="small" />}
                        color="#757575"
                      />
                      <SummaryCard
                        title="Loaded"
                        value={summary.loaded}
                        icon={<LocalShippingRoundedIcon fontSize="small" />}
                        color="#0288d1"
                      />
                      <SummaryCard
                        title="Unloaded"
                        value={summary.unloaded}
                        icon={<PlaylistAddCheckCircleRoundedIcon fontSize="small" />}
                        color="#ed6c02"
                      />
                      <SummaryCard
                        title="Delivered"
                        value={summary.delivered}
                        icon={<CheckCircleRoundedIcon fontSize="small" />}
                        color="#2e7d32"
                      />
                      <SummaryCard
                        title="Undelivered"
                        value={summary.undelivered}
                        icon={<ErrorOutlineRoundedIcon fontSize="small" />}
                        color="#d32f2f"
                      />
                    </Box>

                    <Box
                      sx={{
                        height: 560,
                        width: "100%",
                        "& .MuiDataGrid-root": {
                          border: "none",
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: "#eef6ff",
                          borderBottom: "1px solid #d6e4f0",
                          minHeight: "44px !important",
                          maxHeight: "44px !important",
                        },
                        "& .MuiDataGrid-columnHeader": {
                          padding: "0 10px",
                          outline: "none !important",
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                          fontWeight: 700,
                          fontSize: "0.78rem",
                          color: "#1f2937",
                        },
                        "& .MuiDataGrid-columnSeparator": {
                          display: "none",
                        },
                        "& .MuiDataGrid-cell": {
                          borderBottom: "1px solid rgba(224,224,224,0.55)",
                          fontSize: "0.78rem",
                          display: "flex",
                          alignItems: "center",
                          padding: "0 10px",
                          outline: "none !important",
                        },
                        "& .MuiDataGrid-row": {
                          maxHeight: "40px !important",
                          minHeight: "40px !important",
                        },
                        "& .MuiDataGrid-row:hover": {
                          backgroundColor: "rgba(25,118,210,0.04)",
                        },
                        "& .MuiDataGrid-footerContainer": {
                          minHeight: "42px",
                          borderTop: "1px solid rgba(224,224,224,0.7)",
                        },
                      }}
                    >
                      <DataGrid
                        rows={filteredRows}
                        columns={compactColumns}
                        getRowId={(row) => row.id}
                        loading={loading}
                        disableSelectionOnClick
                        rowHeight={40}
                        headerHeight={44}
                        pageSize={25}
                        rowsPerPageOptions={[25, 50, 100]}
                        density="standard"
                        disableColumnMenu
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 2,
                          backgroundColor: "background.paper",
                          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
                            outline: "none",
                          },
                        }}
                      />
                    </Box>
                  </Stack>
                </LocalizationProvider>
              </Box>
            </Card>

            <Dialog
              open={detailsOpen}
              onClose={closeDetails}
              maxWidth="lg"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  overflow: "hidden",
                },
              }}
            >
              <DialogTitle
                sx={{
                  px: 2,
                  py: 1.5,
                  background:
                    "linear-gradient(90deg, rgba(25,118,210,0.10) 0%, rgba(25,118,210,0.03) 100%)",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  pr: 7,
                }}
              >
                <Typography variant="h6" fontWeight={700}>
                  Delivery Details
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {selectedRow?.billno || "-"} | {selectedRow?.partydetails || "-"}
                </Typography>

                <IconButton
                  onClick={closeDetails}
                  sx={{ position: "absolute", right: 12, top: 12 }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent sx={{ p: 2, bgcolor: "#f8fafc" }}>
                {selectedRow && (
                  <Stack spacing={2}>
                    <DetailCard title="Basic Information">
                      <Grid container spacing={1.2}>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem label="Bill No" value={selectedRow.billno} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <DetailItem label="Bill Date" value={formatDate(selectedRow.billdate)} />
                        </Grid>
                        <Grid item xs={12} md={1.8}>
                          <DetailItem label="DLV No" value={selectedRow.dlvno} />
                        </Grid>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem label="Vehicle No" value={selectedRow.vehicleno} />
                        </Grid>
                        <Grid item xs={12} md={3.8}>
                          <DetailItem label="Party Details" value={selectedRow.partydetails} />
                        </Grid>
                        <Grid item xs={12} md={2.4}>
                          <DetailItem label="Delivery Line" value={selectedRow.linename} />
                        </Grid>
                      </Grid>
                    </DetailCard>

                    <DetailCard title="Status Overview">
                      <Grid container spacing={1.2}>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem
                            label="Delivered By"
                            value={selectedRow.delivered_by}
                            modeChip
                          />
                        </Grid>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem
                            label="Unload Entry"
                            value={selectedRow.unload_entry_type}
                            modeChip
                          />
                        </Grid>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem
                            label="Boxwise Status"
                            value={selectedRow.boxwise_status}
                            chip
                          />
                        </Grid>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem
                            label="Delivery Status"
                            value={selectedRow.dlvstatus_text}
                            chip
                          />
                        </Grid>
                        <Grid item xs={12} md={2.2}>
                          <DetailItem
                            label="Final Status"
                            value={selectedRow.final_status}
                            chip
                          />
                        </Grid>
                        <Grid item xs={12} md={1.2}>
                          <DetailItem label="Total" value={selectedRow.total_boxes} />
                        </Grid>
                        <Grid item xs={12} md={1.2}>
                          <DetailItem label="Loaded" value={selectedRow.loaded_boxes} />
                        </Grid>
                        <Grid item xs={12} md={1.2}>
                          <DetailItem label="Unloaded" value={selectedRow.unloaded_boxes} />
                        </Grid>
                      </Grid>
                    </DetailCard>

                    <DetailCard title="Load / Unload Timing">
                      <Grid container spacing={1.2}>
                        <Grid item xs={12} md={2.4}>
                          <DetailItem label="Load Date" value={formatDate(selectedRow.loaddate)} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <DetailItem label="Load Time" value={formatTime(selectedRow.loadtime)} />
                        </Grid>
                        <Grid item xs={12} md={2.4}>
                          <DetailItem label="Unload Date" value={formatDate(selectedRow.unloaddate)} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <DetailItem label="Unload Time" value={formatTime(selectedRow.unloadtime)} />
                        </Grid>
                      </Grid>
                    </DetailCard>

                    <DetailCard title="Documents">
                      <Grid container spacing={1.2}>
                        <Grid item xs={12} md={3}>
                          <DetailItem
                            label="Load Document"
                            value={selectedRow.has_load_document}
                            doc
                            onDocClick={() =>
                              fetchAndPreviewDocument(
                                selectedRow.loadid,
                                "load",
                                "Load Document",
                                `load_document_${selectedRow.loadid}`
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <DetailItem
                            label="Customer Sign"
                            value={selectedRow.has_customer_sign}
                            doc
                            onDocClick={() =>
                              fetchAndPreviewDocument(
                                selectedRow.loadid,
                                "sign",
                                "Customer Sign",
                                `customer_sign_${selectedRow.loadid}`
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <DetailItem
                            label="CN Document"
                            value={selectedRow.has_unload_cn_document}
                            doc
                            onDocClick={() =>
                              fetchAndPreviewDocument(
                                selectedRow.loadid,
                                "cn",
                                "CN Document",
                                `cn_document_${selectedRow.loadid}`
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <DetailItem
                            label="Receipt Document"
                            value={selectedRow.has_receipt_document}
                            doc
                            onDocClick={() =>
                              fetchAndPreviewDocument(
                                selectedRow.loadid,
                                "receipt",
                                "Receipt Document",
                                `receipt_document_${selectedRow.loadid}`
                              )
                            }
                          />
                        </Grid>
                      </Grid>
                    </DetailCard>

                    <DetailCard title="Box Details">
                      <TableContainer
                        component={Paper}
                        variant="outlined"
                        sx={{ borderRadius: 2, boxShadow: "none" }}
                      >
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ bgcolor: "#f4f8fc" }}>
                              <TableCell sx={{ fontWeight: 700 }}>Box No</TableCell>
                              <TableCell sx={{ fontWeight: 700 }}>Load</TableCell>
                              <TableCell sx={{ fontWeight: 700 }}>Unload</TableCell>
                              <TableCell sx={{ fontWeight: 700 }}>Delivered By</TableCell>
                              <TableCell sx={{ fontWeight: 700 }}>Unload Entry</TableCell>
                              <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedRow.box_details?.length > 0 ? (
                              selectedRow.box_details.map((box, index) => (
                                <TableRow key={index} hover>
                                  <TableCell sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
                                    {box.boxno || "-"}
                                  </TableCell>
                                  <TableCell>{getSimpleChip(box.loadflag, "Yes", "No")}</TableCell>
                                  <TableCell>{getSimpleChip(box.unloadflag, "Yes", "No")}</TableCell>
                                  <TableCell>{getModeChip(box.delivered_by || "N/A")}</TableCell>
                                  <TableCell>{getModeChip(box.unload_entry_type || "N/A")}</TableCell>
                                  <TableCell>{getStatusChip(box.box_status || "Pending")}</TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={6} align="center">
                                  No box details found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </DetailCard>
                  </Stack>
                )}
              </DialogContent>
            </Dialog>

            <Modal
              open={previewOpen}
              onClose={closePreviewModal}
              closeAfterTransition
              slots={{ backdrop: Backdrop }}
              slotProps={{
                backdrop: {
                  timeout: 250,
                },
              }}
            >
              <Fade in={previewOpen}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "96vw", md: "88vw" },
                    height: { xs: "88vh", md: "90vh" },
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 3,
                    outline: "none",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.1,
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1,
                      flexShrink: 0,
                      flexWrap: "wrap",
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle1" fontWeight={700} noWrap>
                        {previewTitle || "Document Preview"}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" noWrap>
                        {selectedRow?.billno || "-"} | {selectedRow?.partydetails || "-"}
                      </Typography>
                    </Box>

                    <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
                      {previewIsImage && !previewLoading && !!previewUrl && (
                        <>
                          <Tooltip title="Rotate Left">
                            <IconButton onClick={() => setRotation((prev) => prev - 90)}>
                              <RotateLeftRoundedIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Rotate Right">
                            <IconButton onClick={() => setRotation((prev) => prev + 90)}>
                              <RotateRightRoundedIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Zoom In">
                            <IconButton onClick={() => setZoom((prev) => Math.min(prev + 0.2, 4))}>
                              <ZoomInRoundedIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Zoom Out">
                            <IconButton onClick={() => setZoom((prev) => Math.max(prev - 0.2, 0.4))}>
                              <ZoomOutRoundedIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Reset View">
                            <IconButton
                              onClick={() => {
                                setRotation(0);
                                setZoom(1);
                              }}
                            >
                              <RestartAltRoundedIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}

                      <Tooltip title="Download">
                        <span>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<DownloadRoundedIcon />}
                            onClick={downloadPreview}
                            disabled={!previewUrl || previewLoading}
                            sx={{ textTransform: "none", borderRadius: 2 }}
                          >
                            Download
                          </Button>
                        </span>
                      </Tooltip>

                      <Tooltip title="Close">
                        <IconButton onClick={closePreviewModal}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: isSignaturePreview ? "#ffffff" : "#0b0f14",
                      backgroundImage: isSignaturePreview
                        ? "linear-gradient(45deg, #f5f5f5 25%, transparent 25%), linear-gradient(-45deg, #f5f5f5 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f5f5f5 75%), linear-gradient(-45deg, transparent 75%, #f5f5f5 75%)"
                        : "none",
                      backgroundSize: isSignaturePreview ? "20px 20px" : "auto",
                      backgroundPosition: isSignaturePreview
                        ? "0 0, 0 10px, 10px -10px, -10px 0px"
                        : "initial",
                    }}
                  >
                    {previewLoading ? (
                      <Stack alignItems="center" spacing={2}>
                        <CircularProgress />
                        <Typography color={isSignaturePreview ? "#111" : "#fff"}>
                          Loading document...
                        </Typography>
                      </Stack>
                    ) : previewError ? (
                      <Stack alignItems="center" spacing={1.5}>
                        <ErrorOutlineRoundedIcon
                          sx={{ color: isSignaturePreview ? "#111" : "#fff", fontSize: 44 }}
                        />
                        <Typography color={isSignaturePreview ? "#111" : "#fff"} fontWeight={600}>
                          {previewError}
                        </Typography>
                      </Stack>
                    ) : previewUrl ? (
                      previewIsPdf ? (
                        <iframe
                          src={previewUrl}
                          title={previewTitle}
                          style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            background: "#fff",
                          }}
                        />
                      ) : previewIsImage ? (
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            overflow: "auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 2,
                          }}
                        >
                          <Box
                            component="img"
                            src={previewUrl}
                            alt={previewTitle}
                            sx={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              userSelect: "none",
                              transform: `rotate(${rotation}deg) scale(${zoom})`,
                              transformOrigin: "center center",
                              transition: "transform 0.2s ease",
                              backgroundColor: isSignaturePreview ? "#fff" : "transparent",
                              border: isSignaturePreview ? "1px solid #ddd" : "none",
                              borderRadius: isSignaturePreview ? 1 : 0,
                              p: isSignaturePreview ? 1 : 0,
                              boxShadow: isSignaturePreview
                                ? "0 2px 12px rgba(0,0,0,0.12)"
                                : "none",
                            }}
                          />
                        </Box>
                      ) : (
                        <Typography color={isSignaturePreview ? "#111" : "#fff"}>
                          Preview not supported
                        </Typography>
                      )
                    ) : (
                      <Typography color={isSignaturePreview ? "#111" : "#fff"}>
                        No preview available
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Fade>
            </Modal>
          </Box>
        }
      />
      {redirectToLoginPage()}
    </div>
  );
};

export default DlvStatus;